import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Link',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { width: "19", height: "12", viewBox: "0 0 19 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }
      }, ctx.data]),
      [h("path", {
        attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M.821 6A5.333 5.333 0 016.155.667H8.82v1.777H6.155a3.556 3.556 0 000 7.112H8.82v1.777H6.155A5.333 5.333 0 01.82 6zm9.778 5.333h2.667a5.333 5.333 0 100-10.666h-2.667v1.777h2.667a3.556 3.556 0 110 7.112h-2.667v1.777z", fill: "currentColor" }
      }), h("rect", {
        attrs: { x: "5.266", y: "5.111", width: "8.889", height: "1.778", rx: ".5", fill: "currentColor" }
      })]
    );
  }
};